module.exports = __webpack_public_path__ + "img/dp2.765c83e0.jpg";